<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Drawer from "@/components/drawer";

// custom components
import PageHeader from "@/components/page-header";
import StaffShift from "@/components/staffShift.vue";
import errorHandler from "@/helpers/errorHandler";
import hkService from "@/helpers/APIService/hk.service";
import { authComputed } from "@/state/helpers";

export default {
  name: "Staff_shift",
  props: {
    currentProps: Object,
  },
  components: {
    PageHeader,
    DatePicker,
    Drawer,
    StaffShift,
  },
  data() {
    return {
      title: "Staff Shift",
      selectedDate: moment().format("YYYY-MM-DD"),
      Table: {
        tableData: [],
        is_data_loading: true,
      },
      openStaffShift: false,
    };
  },
  watch: {
    selectedDate: function (val) {
      if (val !== null) {
        this.selectedDate = moment(val).format("YYYY-MM-DD");
        this.getStaffShiftList();
      }
    },
  },
  computed: {
    ...authComputed,
    staffShiftProps() {
      return {
        date: this.selectedDate,
      };
    },
  },
  mounted() {
    this.getStaffShiftList();
  },
  methods: {
    // Method is for get staff shift
    getStaffShiftList() {
      this.Table.is_data_loading = true;
      hkService
        .getStaffShift(this.selectedDate)
        .then((response) => {
          this.Table.tableData = response;
          this.Table.is_data_loading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use to add staff shift
    staffShiftAdded(data) {
      this.Table.tableData.push(data);
      this.staffShiftForm();
    },
    // Method is use to add staff shift continue
    saveAndAddNewStaffShift(data) {
      this.Table.tableData.push(data[0]);
      this.staffShiftForm();
    },
    // Method is use for open and close staff shift form
    staffShiftForm() {
      this.openStaffShift = !this.openStaffShift;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      text="Add New Staff Shift"
      :action="staffShiftForm"
      :isButton="true"
      :title="title"
    />
    <div class="row">
      <div class="col-xl-12 col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3 align-items-center">
              <div class="col-md-3">
                <span class="d-flex">
                  <span class="me-2 mt-2"><b> Date:</b></span>
                  <date-picker
                    lang="en"
                    placeholder="MM-DD-YYYY"
                    v-model="selectedDate"
                    type="date"
                    value-type="format"
                  ></date-picker>
                </span>
              </div>
              <div class="col-md-9">
                <div class="d-flex justify-content-end">
                  <span class="me-2"><b>Status :</b></span>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-success fs-5 mx-1"></i>
                    <p class="mb-0">Completed</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-warning fs-5 mx-1"></i>
                    <p class="mb-0">Pending</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-circle text-danger fs-5 mx-1"></i>
                    <p class="mb-0">Leave</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive mb-0">
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    v-infinite-scroll="getStaffShiftList"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>ID#</th>
                        <th>Date</th>
                        <th>User</th>
                        <th>Started</th>
                        <th>Ended</th>
                        <th>Break</th>
                        <th>Total Duration</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody v-if="Table.is_data_loading">
                      <tr v-for="item in 10" :key="item">
                        <td class="placeholder-glow" v-for="no in 8" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in Table.tableData" :key="index">
                        <td>{{ data.shift_id }}</td>
                        <td>{{ global_format_date(data.shift_date) }}</td>
                        <td>{{ data.staff_user.name }}</td>
                        <td>
                          {{ data.start_time != null ? data.start_time : "-" }}
                        </td>
                        <td>
                          {{ data.end_time != null ? data.end_time : "-" }}
                        </td>
                        <td>
                          {{
                            data.break_duration != null
                              ? data.break_duration
                              : "-"
                          }}
                        </td>
                        <td>
                          {{
                            data.total_duration != null
                              ? data.total_duration
                              : "-"
                          }}
                        </td>
                        <td>
                          <span
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.status == 'active'
                                ? 'badge-soft-success'
                                : data.status == 'pending'
                                ? 'badge-soft-danger'
                                : 'badge-soft-warning',
                            ]"
                            >{{
                              data.status == "active"
                                ? "Active"
                                : data.status == "pending"
                                ? "Pending"
                                : "Completed"
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody
                      v-if="
                        !Table.is_data_loading && Table.tableData.length == 0
                      "
                    >
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Drawer
      @close="staffShiftForm()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openStaffShift">
        <StaffShift
          :currentProps="staffShiftProps"
          @submitted="staffShiftAdded"
          @cancelSubmit="staffShiftForm"
          @saveAndAddNew="saveAndAddNewStaffShift"
        />
      </div>
    </Drawer>
  </div>
</template>
